import { FC, useCallback, useEffect } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { RadioFilterSelector } from '@frontend/analytics-shared';
import { useOptionsProvider } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../tracking-ids';
import { useCallIntelFiltersContext } from '../context/call-intel-filters.context';
import { FilterTraySection } from './filter-tray-section/filter-tray-section';

export const CallDirectionFilterTray: FC<{ disabled?: boolean; showClear?: boolean }> = ({
  disabled,
  showClear = true,
}) => {
  const { t } = useTranslation('call-intelligence');
  const { filterValues, updateFilterValues, updateFilterModified, isLoading } = useCallIntelFiltersContext();
  const { getOptions } = useOptionsProvider();

  const isDisabled = disabled || isLoading;

  const onChange = useCallback(
    (value: CallIntelTypes.CallDirectionEnum | undefined) => {
      updateFilterValues({ callDirection: value });
    },
    [updateFilterValues]
  );

  useEffect(() => {
    updateFilterModified({ callDirection: !!filterValues.callDirection });
  }, [filterValues.callDirection, updateFilterModified]);

  return (
    <FilterTraySection
      label={t('Call Direction')}
      disableClear={isDisabled}
      showClear={showClear}
      onClear={() => onChange(undefined)}
    >
      <RadioFilterSelector<CallIntelTypes.CallDirectionEnum>
        label={t('Call Direction')}
        onChange={onChange}
        options={getOptions('callDirection')}
        showLabel={false}
        trackingId={trackingIds.callIntel.callDirectionFilter}
        value={filterValues.callDirection}
        withBorder={false}
        disabled={isDisabled}
      />
    </FilterTraySection>
  );
};
